/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Swarm_PatternsInputs */

const en_svchip_swarm_patterns = /** @type {(inputs: Svchip_Swarm_PatternsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swarm patterns`)
};

const ar_svchip_swarm_patterns = /** @type {(inputs: Svchip_Swarm_PatternsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنماط السرب`)
};

const bn_svchip_swarm_patterns = /** @type {(inputs: Svchip_Swarm_PatternsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সোয়াম প্যাটার্ন`)
};

const de_svchip_swarm_patterns = /** @type {(inputs: Svchip_Swarm_PatternsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwarmmuster`)
};

const es_svchip_swarm_patterns = /** @type {(inputs: Svchip_Swarm_PatternsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patrones de enjambre`)
};

const fr_svchip_swarm_patterns = /** @type {(inputs: Svchip_Swarm_PatternsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèles d'essaims`)
};

const pt_svchip_swarm_patterns = /** @type {(inputs: Svchip_Swarm_PatternsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padrões de enxame`)
};

const zh_svchip_swarm_patterns = /** @type {(inputs: Svchip_Swarm_PatternsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`群体模式`)
};

const tr_svchip_swarm_patterns = /** @type {(inputs: Svchip_Swarm_PatternsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sürü desenleri`)
};

const ru_svchip_swarm_patterns = /** @type {(inputs: Svchip_Swarm_PatternsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шаблоны роя`)
};

const pl_svchip_swarm_patterns = /** @type {(inputs: Svchip_Swarm_PatternsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wzory roju`)
};

/**
* | output |
* | --- |
* | "Swarm patterns" |
*
* @param {Svchip_Swarm_PatternsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_swarm_patterns = /** @type {((inputs?: Svchip_Swarm_PatternsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Swarm_PatternsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_swarm_patterns(inputs)
	if (locale === "bn") return bn_svchip_swarm_patterns(inputs)
	if (locale === "de") return de_svchip_swarm_patterns(inputs)
	if (locale === "es") return es_svchip_swarm_patterns(inputs)
	if (locale === "fr") return fr_svchip_swarm_patterns(inputs)
	if (locale === "pt") return pt_svchip_swarm_patterns(inputs)
	if (locale === "zh") return zh_svchip_swarm_patterns(inputs)
	if (locale === "tr") return tr_svchip_swarm_patterns(inputs)
	if (locale === "ru") return ru_svchip_swarm_patterns(inputs)
	if (locale === "pl") return pl_svchip_swarm_patterns(inputs)
	return en_svchip_swarm_patterns(inputs)
});